import { createContext, useContext } from 'react';
import pt from '../i18n/pt';
import en from '../i18n/en';
import { BRAND_THEMES, THEME_BY_ROUTE } from '../i18n/routes';

const SiteContext = createContext(null);
const DICTS = { pt, en };

export function SiteProvider({ lang, routeKey, children }) {
  const t = DICTS[lang] || pt;
  const theme = BRAND_THEMES[THEME_BY_ROUTE[routeKey] || 'group'];
  return (
    <SiteContext.Provider value={{ lang, routeKey, t, theme }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error('useSite must be used within SiteProvider');
  return ctx;
}
